import React from 'react';
import styled from 'styled-components';

import { useTextEditorContext } from 'components/text_editor/text_editor_context';

const StyledSipHighlight = styled.span`
  border-bottom: 1px dashed ${p => p.theme.colors.green400};
  color: ${p => p.theme.colors.green400};
  cursor: pointer;

  &:hover {
    color: ${p => p.theme.colors.green600};
  }
`;

export default function SipHighlight({ attributes, children, editor, node, start, end, text }) {
  const { data, setDataValue } = useTextEditorContext();

  const onClick = () => {
    if (data.sipHighlight) {
      setDataValue('sipHighlight', null);
    } else {
      const document = editor.value.document;
      setDataValue('sipHighlight', {
        path: document.getPath(node),
        key: node.key,
        start,
        end,
        text,
      });
    }
  };

  return (
    <StyledSipHighlight
      data-aid="sip-highlight"
      data-end={end}
      data-key={node.key}
      data-start={start}
      onClick={onClick}
      {...attributes}
    >
      {children}
    </StyledSipHighlight>
  );
}
